<script setup lang="ts">
import JournalCard from '@/entities/journal/ui/JournalCard.vue';
import { ROOT_JOURNAL_URL } from '@/shared/constants/urlConstants';

import type { IJournalArticle } from '@/entities/journal/model/types';

const props = withDefaults(
  defineProps<{
    section: IJournalArticle[];
    title?: string;
    themeSlug?: string;
    isDetailPage?: boolean;
    isTopics?: boolean;
  }>(),
  {
    title: '',
    themeSlug: '',
    isDetailPage: false,
    isTopics: false,
  },
);

const isMobile: boolean = useIsMobile();

const topicLink: ComputedRef<string> = computed(
  () => `${ROOT_JOURNAL_URL}${props.themeSlug}/`,
);
</script>

<template>
  <div
    :class="['journal-card-section', { _mobile: isMobile }, { _detail: isDetailPage }]"
  >
    <div v-if="isTopics" class="journal-card-section__header">
      <h2 class="journal-card-section__title">
        <NuxtLink
          :class="['journal-card-section__link', { _mobile: isMobile }]"
          :to="topicLink"
        >
          {{ title }}
          <AppIcon
            name="ArrowRightJournal"
            :class="['journal-card-section__icon', { _mobile: isMobile }]"
          />
        </NuxtLink>
      </h2>
    </div>
    <div class="journal-card-section__list">
      <JournalCard
        v-for="card in section"
        :key="card.id"
        :card="card"
        :is-detail-page="isDetailPage"
      />
    </div>
  </div>
</template>

<style lang="less">
.journal-card-section {
  .flex-column(@size-x6);

  &__list {
    display: grid;
    gap: @size-x5;
    row-gap: @size-x10;
    grid-template-columns: repeat(auto-fill, minmax(23%, 1fr));
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: @size-x3;
  }

  &__title {
    .h-offset-reset();
  }

  &__link {
    .color-change-hover();

    font-size: @size-x6;
    line-height: 18px;
    font-weight: 700;
    word-break: break-word;
  }

  &__icon {
    width: @size-x5;
    height: @size-x5;
    vertical-align: middle;
    margin-left: 2px;

    path {
      fill: @color-persimmon;
    }
  }

  &._mobile &__list {
    row-gap: @size-x5;
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  }

  &._mobile:not(._detail) &__list {
    .horizontal-scroll-snap();

    border-bottom: 0;
  }
}
</style>
